module.exports = __webpack_public_path__ + "static/img/组 9@2x.959954a5.png";